import React from "react";
import PropTypes from "prop-types";
import { Card, CardHeader, CardBody } from "shards-react";

import colors from "../../utils/colors";
import Chart from "../../utils/chart";
import './loaderStyles.css';

class UsersByDevice extends React.Component {
  constructor(props) {
    super(props);

    this.canvasRef = React.createRef();
    this.chartInstance = null;
  }

  componentDidMount() {
    if (!this.props.loading) {
      this.updateChart();
    }
  }

  componentDidUpdate(prevProps) {
    // Only update the chart if the chartData prop changes and it's not loading
    if ((prevProps.chartData !== this.props.chartData || prevProps.loading !== this.props.loading) && !this.props.loading) {
      this.updateChart();
    }
  }

  updateChart() {
    const chartConfig = {
      type: "doughnut",
      options: {
        legend: false,
        cutoutPercentage: 80,
        tooltips: {
          enabled: false,
          mode: "index",
          position: "nearest",
        },
        ...this.props.chartOptions,
      },
      data: this.props.chartData,
    };

    // If chart instance already exists, destroy it before creating a new one
    if (this.chartInstance) {
      this.chartInstance.destroy();
    }

    this.chartInstance = new Chart(this.canvasRef.current, chartConfig);
  }

  render() {
    const { title, loading } = this.props;
    const labels = this.getParsedLabels();

    return (
      <Card small className="ubd-stats h-100">
        <CardHeader className="border-bottom">
          <h6 className="m-0">{title}</h6>
          <div className="block-handle" />
        </CardHeader>

        <CardBody className="d-flex flex-column" style={{ position: 'relative', minHeight: '250px' }}>
          {loading ? (
            <div className="loader-container" style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
              <div className="spinner"></div> {/* Circular rotating loader */}
            </div>
          ) : (
            <>
              {/* Chart */}
              <canvas
                width="100"
                ref={this.canvasRef}
                className="analytics-users-by-device mt-3 mb-4"
              />
              {/* Legend */}
              <div className="ubd-stats__legend w-75 m-auto pb-4">
                {labels.map((label, idx) => (
                  <div key={idx} className="ubd-stats__item">
                    {label.icon && (
                      <div
                        dangerouslySetInnerHTML={{ __html: label.icon }}
                        style={{ color: label.iconColor }}
                      />
                    )}
                    <span className="ubd-stats__category">{label.title}</span>
                    <span className="ubd-stats__value">{label.value}%</span>
                  </div>
                ))}
              </div>
            </>
          )}
        </CardBody>

        {/*
        <CardFooter className="border-top">
          <Row>
            <Col>
              <FormSelect
                size="sm"
                value="last-week"
                style={{ maxWidth: "130px" }}
                onChange={() => {}}
              >
                <option value="last-week">Last Week</option>
                <option value="today">Today</option>
                <option value="last-month">Last Month</option>
                <option value="last-year">Last Year</option>
              </FormSelect>
            </Col>

            <Col className="text-right view-report">
              <a href="#">View full report &rarr;</a>
            </Col>
          </Row>
        </CardFooter>
        */}
      </Card>
    );
  }

  getParsedLabels() {
    const { chartData } = this.props;

    if (!chartData || !chartData.labels || !chartData.datasets || chartData.datasets.length === 0) {
      return [];
    }

    return chartData.labels.map((label, idx) => {
      const dataset = chartData.datasets[0];

      return {
        title: label,
        icon: dataset.icons[idx],
        iconColor: dataset.backgroundColor[idx],
        value: dataset.data[idx],
      };
    });
  }
}

UsersByDevice.propTypes = {
  /**
   * The card's title.
   */
  title: PropTypes.string,
  /**
   * The Chart.js options.
   */
  chartOptions: PropTypes.object,
  /**
   * The chart data.
   */
  chartData: PropTypes.object,
  /**
   * Loading state for the chart.
   */
  loading: PropTypes.bool,
};

UsersByDevice.defaultProps = {
  title: "Devices Per OS",
  chartOptions: Object.create(null),
  chartData: {
    labels: ["Android", "iOS"],
    datasets: [
      {
        hoverBorderColor: colors.white.toRGBA(1),
        data: [0, 0], // Default data values
        icons: [
          '<i class="fab fa-android"></i>', // Android icon
          '<i class="fab fa-apple"></i>',  // iOS icon
        ],
        backgroundColor: [
          colors.primary.toRGBA(0.9),
          colors.primary.toRGBA(0.5),
        ],
      },
    ],
  },
  loading: true, // Default loading state
};

export default UsersByDevice;
